import React from 'react'
import { Link } from "react-router-dom";
import logo from "../Blogger-Logo-2010.png";
import "../App.css"
const Navbar = () => {
    return (
        <div >
            <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-4 ">
                <div className="container-fluid">
                    <div className="navbar-brand" >
                        <img src={logo} alt='logo ' style={{ height: "3rem" }} />Blog App</div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">

                            <li className="nav-item">
                                <Link to="/" className="nav-link active">Create Post</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/all" className="nav-link active">View All</Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
